module.exports = __webpack_public_path__ + "img/00007.ef3927db.webp";